module.exports = __webpack_public_path__ + "static/media/science2096-1.d3847839.png";